import { render, staticRenderFns } from "./EventResults.vue?vue&type=template&id=5a76319b&scoped=true"
import script from "./EventResults.vue?vue&type=script&lang=js"
export * from "./EventResults.vue?vue&type=script&lang=js"
import style0 from "./EventResults.vue?vue&type=style&index=0&id=5a76319b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76319b",
  null
  
)

export default component.exports